import React from "react";
import "./Guidelines.css";
import { Accordion } from "react-bootstrap";

const Guidelines = ({ guidelines }) => {
  return (
    <section className="Guidelines">
      <div className="container">
        <div className="title_div">
          <p className="title_text">Guidelines</p>
        </div>

        <div className="content_holder">
          <Accordion defaultActiveKey="0">
            {guidelines?.map((data, index) => {
              return (
                <Accordion.Item className="outer_accordion_item" eventKey={index}>
                  <div className="inner_accordion_holder">
                    <Accordion.Header>{data?.title}</Accordion.Header>
                    <Accordion.Body>
                      {data?.descn}
                    </Accordion.Body>
                  </div>
                </Accordion.Item>
              );
            })}
          </Accordion>
        </div>
      </div>
    </section>
  );
};

export default Guidelines;
